import React from 'react'
import { classToFComponent, FCClassContext, FieldHelp, switchSx } from 'src/utils/views'
import { Logger } from 'wdc-cube'

import Switch from '@mui/material/Switch'

import { EnchenteRs2024Scope } from '../../tcm_scopes'
import { FilterSwitchLabel, FilterSwitchRow } from 'src/utils/views/modules/the-consumer-market'

const LOG = Logger.get('EnchenteRs2024View')

export type EnchenteRs2024ViewProps = {
    className?: string
    scope: EnchenteRs2024Scope
}

class EnchenteRs2024ViewClass implements FCClassContext<EnchenteRs2024ViewProps> {
    scope!: EnchenteRs2024Scope

    render({ className, scope }: EnchenteRs2024ViewProps) {
        this.scope = scope
        return (
            <FilterSwitchRow className={className}>
                <Switch
                    id="tcmEnchenteRs2024"
                    size="small"
                    sx={switchSx}
                    checked={scope.active}
                    onChange={this.emitOnChange}
                />
                <div>
                    <FilterSwitchLabel htmlFor="tcmEnchenteRs2024">Enchente RS/2024</FilterSwitchLabel>
                    <FieldHelp>Restringe a consulta aos municípios atingidos pela enchente.</FieldHelp>
                </div>
            </FilterSwitchRow>
        )
    }

    readonly emitOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.scope.onChange(e.target.checked).catch(LOG.caught)
    }
}

export const EnchenteRs2024View = classToFComponent(EnchenteRs2024ViewClass, React)
export default EnchenteRs2024View
